import React, { useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { BACKEND_URL } from "@/config";
import { buildApiCandidates, shouldFailoverBackendRequest } from "@/backendBases";

const API = BACKEND_URL;

export default function ProfileTab({ personnelName }) {
  const [pwLoading, setPwLoading] = useState(false);
  const [rpLoading, setRpLoading] = useState(false);
  const [pw, setPw] = useState({
    old1: "",
    old2: "",
    new1: "",
    new2: "",
  });
  const [rp, setRp] = useState({
    old1: "",
    old2: "",
    new1: "",
    new2: "",
  });

  const postWithFailover = async (path, body) => {
    const candidates = buildApiCandidates(API);
    let lastErr = null;
    for (const base of candidates) {
      const url = base ? `${base}${path}` : path;
      try {
        return await axios.post(url, body, { timeout: 20000 });
      } catch (err) {
        lastErr = err;
        if (shouldFailoverBackendRequest(err)) continue;
        throw err;
      }
    }
    throw lastErr || new Error("Sunucuya bağlanılamadı.");
  };

  const readError = (err, fallback) => {
    const d = err?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.join(" ");
    return err?.message || fallback;
  };

  const submitPassword = async (e) => {
    e.preventDefault();
    setPwLoading(true);
    try {
      await postWithFailover("/api/auth/change-password", {
        current_password: pw.old1,
        current_password_confirm: pw.old2,
        new_password: pw.new1,
        new_password_confirm: pw.new2,
      });
      setPw({ old1: "", old2: "", new1: "", new2: "" });
      toast.success("Şifreniz güncellendi.");
    } catch (err) {
      toast.error(readError(err, "Şifre güncellenemedi."));
    } finally {
      setPwLoading(false);
    }
  };

  const submitRecoveryParola = async (e) => {
    e.preventDefault();
    setRpLoading(true);
    try {
      await postWithFailover("/api/auth/change-recovery-parola", {
        current_parola: rp.old1,
        current_parola_confirm: rp.old2,
        new_parola: rp.new1,
        new_parola_confirm: rp.new2,
      });
      setRp({ old1: "", old2: "", new1: "", new2: "" });
      toast.success("Kurtarma parolanız güncellendi.");
    } catch (err) {
      toast.error(readError(err, "Kurtarma parolası güncellenemedi."));
    } finally {
      setRpLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Profilim</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-gray-600">
          {personnelName ? `${personnelName} hesabı için güvenlik bilgileri` : "Hesap güvenlik bilgileri"}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Şifre Değiştir</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={submitPassword} className="grid gap-3 md:grid-cols-2">
            <div className="space-y-1">
              <Label>Eski Şifre</Label>
              <Input type="password" value={pw.old1} onChange={(e) => setPw((s) => ({ ...s, old1: e.target.value }))} required />
            </div>
            <div className="space-y-1">
              <Label>Eski Şifre (Tekrar)</Label>
              <Input type="password" value={pw.old2} onChange={(e) => setPw((s) => ({ ...s, old2: e.target.value }))} required />
            </div>
            <div className="space-y-1">
              <Label>Yeni Şifre</Label>
              <Input type="password" value={pw.new1} onChange={(e) => setPw((s) => ({ ...s, new1: e.target.value }))} required />
            </div>
            <div className="space-y-1">
              <Label>Yeni Şifre (Tekrar)</Label>
              <Input type="password" value={pw.new2} onChange={(e) => setPw((s) => ({ ...s, new2: e.target.value }))} required />
            </div>
            <div className="md:col-span-2">
              <Button type="submit" disabled={pwLoading}>
                {pwLoading ? "Güncelleniyor..." : "Şifreyi Güncelle"}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Kurtarma Parolası Değiştir</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={submitRecoveryParola} className="grid gap-3 md:grid-cols-2">
            <div className="space-y-1">
              <Label>Eski Kurtarma Parolası</Label>
              <Input type="password" value={rp.old1} onChange={(e) => setRp((s) => ({ ...s, old1: e.target.value }))} required />
            </div>
            <div className="space-y-1">
              <Label>Eski Kurtarma Parolası (Tekrar)</Label>
              <Input type="password" value={rp.old2} onChange={(e) => setRp((s) => ({ ...s, old2: e.target.value }))} required />
            </div>
            <div className="space-y-1">
              <Label>Yeni Kurtarma Parolası</Label>
              <Input type="password" value={rp.new1} onChange={(e) => setRp((s) => ({ ...s, new1: e.target.value }))} required />
            </div>
            <div className="space-y-1">
              <Label>Yeni Kurtarma Parolası (Tekrar)</Label>
              <Input type="password" value={rp.new2} onChange={(e) => setRp((s) => ({ ...s, new2: e.target.value }))} required />
            </div>
            <div className="md:col-span-2">
              <Button type="submit" disabled={rpLoading}>
                {rpLoading ? "Güncelleniyor..." : "Kurtarma Parolasını Güncelle"}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
